/**
 * VAT status values stored on the company record (free-form string in API).
 * Options follow common Philippines (BIR) wording; legacy free-text values are surfaced via
 * `companyVatStatusSelectOptions` so existing data stays selectable.
 */
export const COMPANY_VAT_STATUS_OPTIONS: ReadonlyArray<{
  value: string;
  label: string;
}> = [
  { value: '', label: 'Not specified' },
  { value: 'Non-VAT Registered', label: 'Non-VAT Registered' },
  { value: 'VAT Registered', label: 'VAT Registered' },
  { value: 'VAT Exempt', label: 'VAT Exempt' },
  { value: 'Zero-rated', label: 'Zero-rated' },
];

const KNOWN_VALUES = new Set(
  COMPANY_VAT_STATUS_OPTIONS.map((o) => o.value).filter(Boolean),
);

/** Options for `<select>`: includes a one-off entry when the saved value is not in the standard list. */
export function companyVatStatusSelectOptions(
  currentStoredValue: string | undefined,
): { value: string; label: string }[] {
  const v = currentStoredValue?.trim() ?? '';
  if (!v || KNOWN_VALUES.has(v)) {
    return [...COMPANY_VAT_STATUS_OPTIONS];
  }
  return [...COMPANY_VAT_STATUS_OPTIONS, { value: v, label: `${v} (saved)` }];
}
